import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

const Utils = {
    isNumeric: (value: string | undefined): boolean => {
        return typeof value === 'string' && value.trim() !== '' && !Number.isNaN(Number(value))
    },
}
export default Utils
